// Dto
import {
  ContactRegisterDTO,
  ContactRegisterResponseDTO,
  GenderEnum,
  UserInfo,
} from '@/services/AuthService.interface'

// Modle
import RegisterForm from '@/model/Form/RegisterForm'

// Logic
import setUserIdInLocalStorage from '@/logic/contact/setUserIdInLocalStorage'
import resetLoginForm from '@/logic/user-info/resetLoginForm'
import resetRegisterForm from '@/logic/user-info/resetRegisterForm'
import navigateAfterAuth from '@/logic/contact/navigateAfterAuth'
import { saveCdaConsent } from '@/logic/contact/cdaConsent'
import { isCdaOptInEnabledForUser } from '@/logic/contact/isCdaOptInEnabled'

// State
import loggedInUser from '@/state/loggedInUser'
import isAcceptConditions from '@/state/isAcceptConditions'
import isSubscribeNewsletter from '@/state/isSubscribeNewsletter'
import isNewUser from '@/state/isNewUser'

// Store
import store from '@/store'

const register = async (form: RegisterForm) => {
  if (!form.getIsFormValid())
    throw new Error(
      'cannot send an invalid form, make sure you perform this check before making this call'
    )

  isNewUser.value = true

  try {
    const acceptedConditions: boolean = isAcceptConditions.value
    const consentSnapshot = { ...isSubscribeNewsletter.value }

    const registerDTO: ContactRegisterDTO = {
      accept_conditions: acceptedConditions,
      // Auth DTO stays boolean; CDA multi-flags go to CRM after success.
      subscribe_newsletter: !!consentSnapshot.email,
      address: form.address,
      email: form.email,
      password: form.password1,
      country: form.country,
      gender: form.gender || GenderEnum.OTHER,
      postal_code: form.postal_code,
      city: form.city,
      last_name: form.last_name,
      first_name: form.first_name,
      phone_number: form.phone_number,
      phone_code: form.phone_code,
    }

    const registerResponse: ContactRegisterResponseDTO | null =
      await store.dispatch('auth/register', registerDTO)
    if (!registerResponse) throw new Error('REGISTER ERROR')
    if (!registerResponse.tokens)
      throw new Error(
        'register contact response has to contain an object with tokens'
      )

    setUserIdInLocalStorage(registerResponse.userInfo)

    const userInfo: UserInfo = registerResponse.userInfo

    loggedInUser.value = userInfo

    // Soft-fail: never block registration if CRM/Selligent is down.
    // Snapshot before resetRegisterForm clears local consent.
    // Pilot: only push CDA when new iresa id is allowlisted (or `*` / `all`).
    if (isCdaOptInEnabledForUser(userInfo.iresa_id)) {
      await saveCdaConsent(userInfo.email, consentSnapshot, {
        userId: userInfo.iresa_id,
      })
    }

    resetLoginForm()
    resetRegisterForm()
    await navigateAfterAuth(userInfo.email)
  } catch (err) {
    console.error(err)
    throw err
  }
}

export default register
